
export default {
  name: 'PageSplitLayout',
  values: {
    primary: {
      padding: '8px',
      _mobile_padding: 0,
      minWidth: '',
      _desktop_minWidth: '479px',
    },
    secondary: {
      width: '220px',
      margin: '0',
      padding: '8px 0 0 0',
      show: true,
      _mobile_show: false,
    },
  },
  meta: {
    extendable: false,
  },
}
